import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { instance } from "../configApi";

const initialState = {
  msg: "",
  isError: false,
  isNotify: false,
  typeNotify: "",
  isLoading: false,
  callBackRequest: false,
  isOpenModalAddProduct: false,
  isOpenModalDetail: false,
  isOpenModalEdit: false,
  isOpenModalConfirm: false,
  isOpenModalGetLog: false,
  dataLog: [],
  contentConfirm: "",
  idProduct: "",
  isOpenModalAddCategry: false,
  callBackRequestCategory: false,
  dataBasePageOne: [],
  refetchAPI: false,
  detailByID: [],
  data: [],
  total: 0,
  dataCategory: [],
  config: {
    search: "",
    status: 2,
    categoryId: 0,
    option: {
      limit: 10,
      offset: 1,
      order: "desc",
    },
  },
};
const ChatBkavProSlice = createSlice({
  name: "chatBkavPro",
  initialState,
  reducers: {
    resetState: (state) => {
      state.msg = "";
      state.isNotify = false;
      state.typeNotify = "";
      state.isLoading = false;
      state.callBackRequest = false;
      state.isOpenModalAddProduct = false;
      state.isOpenModalDetail = false;
      state.isOpenModalEdit = false;
      state.isOpenModalConfirm = false;
      state.isOpenModalGetLog = false;
      state.dataLog = [];
      state.contentConfirm = "";
      state.idProduct = "";
      state.isOpenModalAddCategry = false;
      state.callBackRequestCategory = false;
      state.detailByID = [];
      state.data = [];
      state.total = 0;
      state.dataCategory = [];
      state.config.search = "";
      state.config.status = 2;
      state.config.categoryId = 0;
      state.config.option.limit = 10;
      state.config.option.offset = 1;
      state.config.option.order = "desc";
    },
    setSearchText: (state, action) => {
      state.config.search = action.payload;
    },
    setStatusProduct: (state, action) => {
      state.config.option.offset = 1;
      state.config.status = action.payload;
    },
    setCategoryId: (state, action) => {
      state.config.categoryId = action.payload;
    },
    setPageProduct: (state, action) => {
      state.config.option.offset = action.payload;
    },
    setOpenDetailChatBkavPro: (state, action) => {
      state.isOpenModalDetail = action.payload.isOpen;
      state.idProduct = action.payload.id;
    },
    resetStatus: (state) => {
      state.isLoading = false;
      state.isNotify = false;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      //add product
      .addCase(createProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createProduct.fulfilled, (state, action) => {
        if (!action.status) {
          state.isError = true;
          state.msg = action.payload.message;
          state.isLoading = false;
        }
        if (action.payload === 200) {
          state.isNotify = true;
          state.isLoading = false;
          state.isError = false;
          state.msg = "Thêm sản phẩm thành công";
          state.callBackRequest = true;
          state.isOpenModalAddProduct = false;
        }
      })
      .addCase(createProduct.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      });
  },
});
export default ChatBkavProSlice;

export const {
  setCategoryId,
  setStatusProduct,
  setOpenEditProduct,
  setOpenDetailChatBkavPro,
  setOpenModalConfirm,
  resetStatus,
  setPageProduct,
  setSearchText,
  setOpenModalAddProduct,
  setOpenModalAddCategory,
  setOpenModalGetLogStore,
  resetState,
} = ChatBkavProSlice.actions;

export const createProduct = createAsyncThunk(
  "store/createProduct",
  async (data) => {
    try {
      const res = await instance.post("/product/createProduct", data, {
        headers: {
          "Content-type": "multipart/form-date",
        },
      });
      return res.status;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
